// extracted by mini-css-extract-plugin
export var arrow = "customer-journey-module--arrow--0fc0a";
export var horizontalConnector = "customer-journey-module--horizontalConnector--b936f";
export var illustration = "customer-journey-module--illustration--b389c";
export var imagePlaceholder = "customer-journey-module--imagePlaceholder--a987c";
export var journeyContainer = "customer-journey-module--journeyContainer--8fa8b";
export var journeyGrid = "customer-journey-module--journeyGrid--bb609";
export var journeyRow = "customer-journey-module--journeyRow--483f2";
export var journeyStepCell = "customer-journey-module--journeyStepCell--7ed44";
export var reverse = "customer-journey-module--reverse--bd12d";
export var rotated = "customer-journey-module--rotated--1b8b6";
export var stepContent = "customer-journey-module--stepContent--538ec";
export var stepNumber = "customer-journey-module--stepNumber--df7a1";
export var textContent = "customer-journey-module--textContent--f383a";
export var verticalConnector = "customer-journey-module--verticalConnector--b6a6f";